import type { EventData } from '../../types'

// Filtering out unecessary keys from the payload?
export const promotionModel = ({ name, creative, position }: EventData) => ({
  name,
  creative,
  position,
})
